module.exports = __webpack_public_path__ + "static/img/1-1.8fca281.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/1-1.png
// module id = DPi2
// module chunks = 0